import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { TipoRol } from '@rpe/registro-personas-empresas-lib/src/lib/tipos-rol/tipos-rol.model';

export const entityTiposRolAdapter: EntityAdapter<TipoRol> =
  createEntityAdapter<TipoRol>({
    selectId: (model) => model.id,
    sortComparer: (a: TipoRol, b: TipoRol): number =>
      a.nombre.toString().localeCompare(b.nombre.toString())
  });

export interface EntityTiposRolState extends EntityState<TipoRol> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityTiposRolState =
  entityTiposRolAdapter.getInitialState({
    isLoading: false,
    error: null
  });
